import React from 'react';

import dabangBridge from '~/utils/bridge';
import isMobile from '~/utils/is-mobile';

import top from './images/top.png';
import bottom from './images/bottom.png';
import urlBtn from './images/url-btn.png';
import signBtn from './images/sign-btn.png';

import { BGWrap } from './styled';

const WematchEventAgain = () => {
  const isM = isMobile.any();

  const clickDetail = () => {
    dabangBridge.web(() => window.location.href = 'https://m.kebhana.com/cont/event/new/event01/1482088_152465.jsp');

    dabangBridge.ios(call => {
      call.callHandler('ObjC Echo', {
        cmd: 'openInAppBrowser',
        url: 'https://m.kebhana.com/cont/event/new/event01/1482088_152465.jsp',
      });
    });

    dabangBridge.android(call => {
      console.log('android');
      call.openInAppBrowser('https://m.kebhana.com/cont/event/new/event01/1482088_152465.jsp');
    });
  };

  const clickGoSignRoomList = () => {
    //모웹접근
    if (dabangBridge.getPlatform() === 'web' && isM) {
      return window.location.href = 'https://dabang.page.link/9Vrq';
    } else {
      const params = {
        api_type: 'BBOX',
        location: JSON.stringify([
          [125.38564393561512, 32.320189184386535],
          [129.9669425751472, 38.85305442043736],
        ]),
        zoom: 9,
      };

      dabangBridge.android(call => {
        console.log('android');
        call.signRoomList(JSON.stringify(params));
      });

      dabangBridge.ios(call => {
        call.callHandler('ObjC Echo', {
          cmd: 'signRoomList',
          params: params,
        });
      });
    }
  };

  return (
    <>
      <BGWrap width={640} height={3076} imgUrl={top}>
        <img src={urlBtn} alt="url" style={{ width: '82%', cursor: 'pointer', position: 'absolute', bottom: '7%',left: '50%', transform: 'translateX(-50%)' }} onClick={clickDetail} />
      </BGWrap>
      <BGWrap width={640} height={1368} imgUrl={bottom}>
        <img src={signBtn} alt="sign" style={{ width: '82%', position: 'absolute', bottom: '7%',left: '50%', transform: 'translateX(-50%)' }} onClick={clickGoSignRoomList} />
      </BGWrap>
    </>
  );
};

export default WematchEventAgain;
